import React from 'react';
import { Clock, LogOut } from 'lucide-react';

export function PendingScreen({ user, onSignOut }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        <div className="flex items-center justify-center mb-6">
          <div className="bg-blue-600 p-3 rounded-xl">
            <Clock className="text-white" size={32} />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-center text-gray-900 mb-2">
          Time Tracker
        </h1>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <h2 className="text-lg font-semibold text-yellow-900 mb-2">
            Access Pending
          </h2>
          <p className="text-sm text-yellow-800 mb-3">
            Your access request is pending approval from an administrator.
          </p>
          <div className="text-sm text-yellow-700 space-y-1">
            <div>
              <span className="font-medium">Email:</span> {user?.email}
            </div>
            <div>
              <span className="font-medium">Status:</span> Waiting for approval
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-600 text-center mb-6">
          You'll receive access once an administrator approves your request.
          You can close this window and check back later.
        </p>

        <button
          onClick={onSignOut}
          className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
        >
          <LogOut size={20} />
          Sign Out
        </button>
      </div>
    </div>
  );
}
